// import dynamic from 'next/dynamic';
import Seo from '../components/common/Seo';
import DefaultHeader from '../components/header/header-rslhome';
import DefaultFooter from '../components/footer/footer-3';
import Block1 from '../components/about/Block1Rsl';
import Block3 from '../components/about/Block1RslCompany';
import Block2 from '../components/about/Block2Rsl';
import { Divider } from '@mui/material';
import { fetchSeoByPage } from '../lib/seoHelper';
// import Block3 from '../components/about/Block3Rsl';

const About = ({ meta }) => {
  return (
    <>
      <Seo meta={meta} />
      <DefaultHeader />
      <section className="">


        <Block1 />
        <Divider sx={{
          borderColor: 'rgba(0,0,0,1)',

        }} />
        <div className="container">
          <Block3 />
          <Block2 />
        </div>

      </section>

      <DefaultFooter />
      {/* End Call To Actions Section */}
    </>
  );
};

// export default dynamic(() => Promise.resolve(About), { ssr: false });
export default About;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}